import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { Logo } from "@/libraries/wpl/foundations/src";

type ProductHeaderProps = {
    productKey: ProductKeys;
    templateName?: string;
    selectedLabel?: string;
};

const ProductHeader = ({
    productKey,
    templateName,
    selectedLabel
}: ProductHeaderProps) => {
    const intl = useIntl();
    const getBrand = (productKey: ProductKeys) => {
        switch (productKey) {
            case ProductKeys.JIRA_SOFTWARE:
                return "jirasoftware";
            case ProductKeys.JIRA_SERVICE_DESK:
                return "jiraproductdiscovery"; // This is broken in the @atlassiansox/wpl-utils package
            case ProductKeys.JIRA_CORE:
                return "jiraworkmanagement";
            case ProductKeys.CONFLUENCE:
            default:
                return "confluence";
        }
    };

    const youSelectedLabel = intl.formatMessage({
        id: "SiteSelectorModal.modalHeader.youSelected",
        defaultMessage: "You selected"
    });

    return (
        <div css={logoWrapperStyle}>
            <Logo
                type={"logo"}
                appearance={"brand"}
                brand={getBrand(productKey)}
            />
            <div css={subHeadlineStyle}>
                {selectedLabel ?? youSelectedLabel}
                <span css={selectedTemplateStyle}>{templateName}</span>
            </div>
        </div>
    );
};

const subHeadlineStyle = css({
    fontSize: "16px"
});

const selectedTemplateStyle = css({
    fontWeight: "bold",
    paddingInlineStart: "5px"
});

const logoWrapperStyle = css({
    svg: {
        maxWidth: "300px"
    }
});

export default ProductHeader;
